export const LAST_VISIT = 'last_visit'
export const PREV_PAGE = 'prev_page'
export const PAGE_PARAM = '?page=0'

export class SessionStorageService {
  static getLastVisitedPage = () => sessionStorage.getItem(LAST_VISIT)

  static getPrevPage = () => sessionStorage.getItem(PREV_PAGE)

  static setLastVisit = path => {
    sessionStorage.setItem(LAST_VISIT, path)
  }

  static setPrevPage = path => {
    sessionStorage.setItem(PREV_PAGE, path)
  }
}
